
















import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {DeletePatientVaEvent, GetPatientVaEventList} from "@/api/vascularAccess"
import AddOrEditEvent from './addOrEditEvent.vue'

@Component({
	components: {AddOrEditEvent}
})
export default class Patient extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	addOrEditDiagShow = false
	editData:any = {}

	form: any = {}
	tableData = []
	columns = [
		{
			title: '操作时间',
			key: 'inputDate',
			render: (h: any, params: any) => {
				return h('span', this.formatDate(params.row.inputDate))
			}
		},
		{
			title: '并发症名称',
			key: 'complicationTag'
		},
		{
			title: '并发症说明',
			key: 'complicationDesc'
		},
		{
			title: '事件来源',
			key: 'eventSource'
		},
		{
			title: '原因',
			key: 'reason'
		},
		{
			title: '处理方式',
			key: 'operationMethod'
		},
		{
			width:160,
			title: '操作',
			render: (h: any, params: any) => {
				return h('div', [
					h('Button',
						{
							props: {
								type: 'primary'
							},
							on:{
								click:()=>{
									this.editOne(params.row)
								}
							}
						},
						'编辑'
					),
					h('Button',
						{
							props: {
								type: 'error'
							},
							on:{
								click:async ()=>{
									this.$confirm('将删除该记录, 是否继续?', '提示', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										type: 'warning'
									}).then(async () => {
										let res = await DeletePatientVaEvent({Id:params.row.id})
										this.init()
									}).catch((e:any) => {
										console.log(e)
									});

								}
							}
						},
						'删除'
					),
				])
			}
		},
	]

	created() {
		this.init()
	}

	addOne(){
		this.editData = {
			mode:'add',
			patient: this.data.patient,
			road: this.data.road,
			name:'通路信息'
		}
		this.addOrEditDiagShow = true
	}

	saveSuccess(){
		this.addOrEditDiagShow = false
		this.init()
	}

	editCancel(){
		this.addOrEditDiagShow = false
	}

	get modalTitle() {
		return '通路事件列表'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	private async init() {
		let res = await GetPatientVaEventList({
			PatientId: this.data.patient.id,
			PatientVaId: this.data.road.id
		})
		this.tableData = res.objects
	}

	private editOne(row: any) {
		this.editData = {
			mode:'edit',
			patient: this.data.patient,
			road: this.data.road,
			name:'通路信息',
			item: row
		}
		this.addOrEditDiagShow = true
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/event.vue